export default __webpack_public_path__ + "static/media/RegulatoryComplianceandSupport.007e6c68.png";